/* Elsie August : le moteur du monde (la cabine d'essayage), 09/10/2026.
   1. Apparitions (.el-rise) et onglets ([data-el-tabs]).
   2. Dessins : chaque .el-art[data-a] est arme puis joue UNE fois a son entree dans la vue
      (trace = le trait se dessine sur sa longueur reelle a l'ecran ; swing / open / steam = mouvements CSS sur .is-on).
      Sans JS ou en mouvement reduit : le dessin est deja fini (rendu serveur).
   3. Dates : livraison estimee sur la fiche et date limite de Noel, calculees sur la politique de livraison
      (7 a 11 jours ouvres, commande apres 14 h MT = jour ouvre suivant, week-ends et feries US exclus).
   4. Ajout au sac : etiquettes qui s'envolent et photo qui file vers le sac. */
(() => {
  const calme = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1. apparitions, onglets ---------- */
  const io = 'IntersectionObserver' in window && !calme ? new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }), { rootMargin: '0px 0px -8% 0px' }) : null;
  document.querySelectorAll('.el-rise').forEach(el => io ? io.observe(el) : el.classList.add('is-in'));
  document.documentElement.classList.add('el-js');

  document.querySelectorAll('[data-el-tabs]').forEach(s => s.addEventListener('click', e => {
    const t = e.target.closest('[role=tab]'); if (!t) return;
    s.querySelectorAll('[role=tab]').forEach(x => { x.setAttribute('aria-selected', x === t); x.classList.toggle('is-on', x === t); });
    s.querySelectorAll('[role=tabpanel]').forEach(p => { p.hidden = p.id !== t.getAttribute('aria-controls'); });
  }));

  /* ---------- 2. dessins ---------- */
  if (!calme && 'IntersectionObserver' in window) {
    const arts = [...document.querySelectorAll('.el-art[data-a], svg[data-a]')];
    const longueur = p => {
      if (!p.getTotalLength) return 0;
      const m = p.getScreenCTM(); if (!m) return 0;
      return Math.ceil(p.getTotalLength() * Math.max(Math.hypot(m.a, m.b), Math.hypot(m.c, m.d))) + 2;
    };
    const cacher = el => el.querySelectorAll('.tr').forEach(p => {
      const L = longueur(p); if (!L) return;
      p.style.strokeDasharray = L + ' ' + L; p.style.strokeDashoffset = L;
    });
    const tracer = el => el.querySelectorAll('.tr').forEach((p, i) => {
      const L = longueur(p); if (!L) { p.style.strokeDasharray = p.style.strokeDashoffset = ''; return; }
      p.style.strokeDasharray = L + ' ' + L; p.style.strokeDashoffset = '';
      p.animate([{ strokeDashoffset: L }, { strokeDashoffset: 0 }], { duration: 1200, delay: 80 + i * 55, easing: 'cubic-bezier(.4,0,.2,1)', fill: 'backwards' })
        .onfinish = () => { p.style.strokeDasharray = ''; };
    });
    const vu = new IntersectionObserver(es => es.forEach(e => {
      if (!e.isIntersecting || e.target.classList.contains('is-on')) return;
      e.target.classList.add('is-on'); tracer(e.target); vu.unobserve(e.target);
    }), { threshold: .3 });
    arts.forEach(el => { if (el.closest('[hidden]')) return; el.classList.add('is-armed'); cacher(el); vu.observe(el); });
    /* filet : un dessin deja depasse (saut d'ancre) ne reste pas cache */
    setTimeout(() => arts.forEach(el => { if (!el.classList.contains('is-on') && el.getBoundingClientRect().bottom < 0) { el.classList.add('is-on'); el.querySelectorAll('.tr').forEach(p => { p.style.strokeDasharray = p.style.strokeDashoffset = ''; }); } }), 4000);
  }

  /* ---------- 3. dates en jours ouvres ---------- */
  const FERIES = new Set((window.EL_FERIES || []).map(s => s.trim()).filter(Boolean));
  const iso = d => d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
  const ouvre = d => d.getDay() !== 0 && d.getDay() !== 6 && !FERIES.has(iso(d));
  const plus = (d, n) => { const x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); if (ouvre(x)) n--; } return x; };
  /* l'heure de Denver (MT) : la regle des 14 h est dans ce fuseau */
  const mt = () => {
    try {
      const p = Object.fromEntries(new Intl.DateTimeFormat('en-US', { timeZone: 'America/Denver', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', hourCycle: 'h23' }).formatToParts(new Date()).map(x => [x.type, x.value]));
      return { d: new Date(+p.year, +p.month - 1, +p.day), h: +p.hour };
    } catch (e) { const n = new Date(); return { d: new Date(n.getFullYear(), n.getMonth(), n.getDate()), h: n.getHours() }; }
  };
  const { d: auj, h: heure } = mt();
  /* jour 0 : aujourd'hui si ouvre et avant 14 h MT, sinon le jour ouvre suivant */
  const depart = ouvre(auj) && heure < 14 ? auj : plus(auj, 1);
  const court = d => d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  const long = d => d.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' });
  const mois = d => d.toLocaleDateString('en-US', { month: 'short' }).toUpperCase();

  const tot = plus(depart, 7), tard = plus(depart, 11);
  document.querySelectorAll('[data-el-eta]').forEach(el => { el.textContent = 'between ' + court(tot) + ' and ' + court(tard); });
  document.querySelectorAll('.el-eta .el-art').forEach(a => {
    const m = a.querySelector('[data-l="m"]'), d = a.querySelector('[data-l="d"]');
    if (m) m.textContent = mois(tard); if (d) d.textContent = tard.getDate();
  });

  /* Noel : le dernier jour de commande dont la livraison la plus lente (11 jours ouvres) tombe au plus tard le 24 decembre */
  const an = auj.getMonth() === 11 && auj.getDate() > 24 ? auj.getFullYear() + 1 : auj.getFullYear();
  const veille = new Date(an, 11, 24);
  let limite = new Date(veille); limite.setDate(limite.getDate() - 30);
  while (plus(ouvre(limite) ? limite : plus(limite, 1), 11) <= veille) limite.setDate(limite.getDate() + 1);
  limite.setDate(limite.getDate() - 1);
  while (!ouvre(limite)) limite.setDate(limite.getDate() - 1);
  const debutSaison = new Date(an, 9, 1);
  const enSaison = auj >= debutSaison && (auj < limite || (+auj === +limite && heure < 14));
  const jours = Math.round((limite - auj) / 864e5);
  document.querySelectorAll('[data-el-season]').forEach(s => {
    if (!enSaison) { s.remove(); return; }
    s.hidden = false;
    s.querySelectorAll('[data-season-date]').forEach(e => { e.textContent = long(limite); });
    s.querySelectorAll('.el-art [data-l="d"]').forEach(e => { e.textContent = limite.getDate(); });
    s.querySelectorAll('.el-art [data-l="m"]').forEach(e => { e.textContent = mois(limite); });
    const l = s.querySelector('[data-season-left]');
    if (l) l.textContent = jours === 0 ? 'That is today, before 2 pm MT.' : jours === 1 ? 'That is tomorrow.' : 'That leaves ' + jours + ' days.';
    /* une section revelee apres coup : ses dessins jouent ici */
    s.querySelectorAll('.el-art[data-a]').forEach(a => a.classList.add('is-on'));
  });
  document.querySelectorAll('[data-el-xmas]').forEach(e => {
    if (!enSaison) return;
    e.textContent = 'For Christmas Eve, order by ' + court(limite) + '.'; e.hidden = false;
  });

  /* ---------- 4. ajout au sac ---------- */
  const sac = () => [...document.querySelectorAll('.el-bagbtn')].find(e => e.offsetParent);
  const bump = () => { const s = sac(); if (!s) return; s.classList.remove('is-bump'); void s.offsetWidth; s.classList.add('is-bump'); };
  document.addEventListener('cart:change', bump);
  document.addEventListener('submit', e => {
    const f = e.target; if (!(f instanceof HTMLFormElement) || !/\/cart\/add/.test(f.action)) return;
    const btn = e.submitter || f.querySelector('[type=submit]') || document.querySelector('[form="' + f.id + '"]');
    if (btn) {
      const lab = btn.querySelector('[data-el-atc-label]') || btn;
      const old = lab.innerHTML;
      setTimeout(() => { btn.classList.add('is-added'); lab.textContent = 'In your bag'; }, 450);
      setTimeout(() => { btn.classList.remove('is-added'); lab.innerHTML = old; }, 2300);
    }
    if (calme) return;
    const r0 = (btn || f).getBoundingClientRect();
    const st = getComputedStyle(document.documentElement);
    const encre = st.getPropertyValue('--el-ink').trim() || '#24272E';
    const fonds = ['--el-paper', '--el-w1', '--el-w2', '--el-rose'].map(v => st.getPropertyValue(v).trim() || '#FDFCFA');
    /* sept etiquettes volantes, chacune avec son oeillet et sa ficelle */
    for (let i = 0; i < 7; i++) {
      const b = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      b.setAttribute('viewBox', '0 0 20 28'); b.classList.add('el-burst');
      b.innerHTML = '<path d="M4 9L10 3L16 9V26H4Z" fill="' + fonds[i % 4] + '" stroke="' + encre + '" stroke-width="1.2" stroke-linejoin="round"/><circle cx="10" cy="9" r="1.6" fill="none" stroke="' + encre + '" stroke-width="1"/><path d="M10 7.4C10 3 13 1 15 0" fill="none" stroke="' + encre + '" stroke-width=".8"/>';
      b.style.left = (r0.left + r0.width / 2 - 7) + 'px'; b.style.top = (r0.top + r0.height / 2 - 10) + 'px';
      document.body.appendChild(b);
      const a = -Math.PI / 2 + (i - 3) * .42 + (Math.random() - .5) * .25, d = 70 + Math.random() * 40;
      b.animate([
        { transform: 'translate(0,0) scale(.3) rotate(0)', opacity: 1 },
        { transform: `translate(${Math.cos(a) * d}px, ${Math.sin(a) * d}px) scale(1) rotate(${(i - 3) * 14}deg)`, opacity: 1, offset: .55 },
        { transform: `translate(${Math.cos(a) * d * 1.15}px, ${Math.sin(a) * d + 70}px) scale(.7) rotate(${(i - 3) * 30}deg)`, opacity: 0 }
      ], { duration: 1000 + Math.random() * 250, easing: 'cubic-bezier(.2,.8,.3,1)' }).onfinish = () => b.remove();
    }
    const zone = f.closest('.el-pcard, [data-el-pdp]') || (btn && btn.closest('.el-sticky') ? document.querySelector('[data-el-pdp]') : null);
    let img = null;
    if (zone) {
      const sl = zone.querySelector('[data-el-slides]');
      img = sl ? sl.children[Math.round(sl.scrollLeft / (sl.clientWidth || 1))]?.querySelector('img') : zone.querySelector('img');
    }
    const cible = sac();
    if (img && cible) {
      const a = img.getBoundingClientRect(), c = cible.getBoundingClientRect();
      const t = img.cloneNode(); t.removeAttribute('srcset'); t.removeAttribute('sizes'); t.removeAttribute('loading'); t.className = 'el-fly';
      const w = Math.min(a.width, 200), h = w * (a.height / a.width || 1.5);
      Object.assign(t.style, { left: (a.left + a.width / 2 - w / 2) + 'px', top: (a.top + a.height / 2 - h / 2) + 'px', width: w + 'px', height: h + 'px' });
      document.body.appendChild(t);
      const dx = c.left + c.width / 2 - (a.left + a.width / 2), dy = c.top + c.height / 2 - (a.top + a.height / 2);
      t.animate([
        { transform: 'translate(0,0) scale(1) rotate(0)', opacity: 1 },
        { transform: `translate(${dx * .45}px, ${dy * .45 - 110}px) scale(.5) rotate(-8deg)`, opacity: 1, offset: .5 },
        { transform: `translate(${dx}px, ${dy}px) scale(.08) rotate(12deg)`, opacity: .5 }
      ], { duration: 900, easing: 'cubic-bezier(.45,0,.25,1)' }).onfinish = () => { t.remove(); bump(); };
    }
  }, true);
})();

/* ---------- tiroir : finir la tenue (le tiroir est re-rendu par le theme, donc ecoute deleguee) ---------- */
(() => {
  document.addEventListener('click', async e => {
    const dot = e.target.closest('[data-el-xsell] [data-el-xv]');
    if (dot) {
      const card = dot.closest('[data-el-xcard]');
      card.querySelectorAll('[data-el-xv]').forEach(b => b.setAttribute('aria-pressed', b === dot ? 'true' : 'false'));
      card.querySelector('[data-el-xadd]').setAttribute('data-el-xadd', dot.dataset.elXv);
      card.querySelector('[data-el-xprice]').textContent = dot.dataset.p;
      const img = card.querySelector('[data-el-ximg]');
      if (img && dot.dataset.img) img.src = dot.dataset.img;
      return;
    }
    const add = e.target.closest('[data-el-xsell] [data-el-xadd]');
    if (!add || add.getAttribute('aria-busy') === 'true') return;
    add.setAttribute('aria-busy', 'true');
    try {
      const r = await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: +add.dataset.elXadd, quantity: 1 }] })
      });
      add.removeAttribute('aria-busy');
      if (!r.ok) { add.classList.add('is-out'); add.textContent = 'Sold out'; return; }
      add.classList.add('is-added'); add.textContent = 'Added';
      setTimeout(() => { if (document.querySelector('[data-el-cart]')) location.reload(); else document.dispatchEvent(new CustomEvent('cart:refresh')); }, 500);
    } catch (_) { add.removeAttribute('aria-busy'); }
  });
})();

/* ---------- Audit 31/10/2026 : taille modifiable dans le tiroir et le panier ---------- */
(() => {
  const root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
  const post = (u, b) => fetch(root + u, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(b) });
  document.addEventListener('change', async e => {
    const s = e.target.closest('[data-el-swap]'); if (!s || s.dataset.busy) return;
    s.dataset.busy = 1; s.disabled = true;
    try {
      const add = await post('cart/add.js', { items: [{ id: +s.value, quantity: +s.dataset.qty || 1 }] });
      if (!add.ok) throw new Error('add');
      // la cle de ligne change apres un ajout : on retire l'ancienne taille par sa variante, relue dans /cart.js
      const c = await (await fetch(root + 'cart.js')).json();
      const old = c.items.find(i => i.variant_id === +s.dataset.vid);
      if (old) await post('cart/change.js', { id: old.key, quantity: 0 });
    } catch (_) { s.disabled = false; delete s.dataset.busy; return; }
    if (document.querySelector('[data-el-cart]')) location.reload(); else document.dispatchEvent(new CustomEvent('cart:refresh'));
  });
})();

/* Audit 31/10 : ajout rapide au doigt sur les cartes (une taille = un geste). */
document.addEventListener('click', async e => {
  const b = e.target.closest('[data-qa-id]'); if (!b) return;
  e.preventDefault(); b.disabled = true;
  const r = await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +b.dataset.qaId, quantity: 1 }] }) });
  b.disabled = false;
  const d = b.closest('details'); if (d) d.open = false;
  if (!r.ok) { b.textContent = 'Sold out'; return; }
  document.dispatchEvent(new CustomEvent('cart:refresh'));
  setTimeout(() => document.querySelector('[aria-controls="cart-drawer"]')?.click(), 350);
});

/* Audit 31/10 : recherche predictive, 6 pieces avec photo et prix des la 2e lettre. */
(() => {
  const root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
  const money = c => '$' + (c / 100).toFixed(2).replace(/\.00$/, '');
  document.querySelectorAll('form[role="search"]').forEach(f => {
    const q = f.querySelector('input[name="q"]'); if (!q) return;
    const box = document.createElement('div'); box.className = 'el-suggest'; box.hidden = true; box.setAttribute('role', 'listbox');
    f.style.position = 'relative'; f.appendChild(box);
    let t, ctl;
    q.setAttribute('autocomplete', 'off');
    q.addEventListener('input', () => {
      clearTimeout(t);
      const v = q.value.trim(); if (v.length < 2) { box.hidden = true; return; }
      t = setTimeout(async () => {
        ctl?.abort(); ctl = new AbortController();
        try {
          const r = await fetch(root + 'search/suggest.json?q=' + encodeURIComponent(v) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=hide', { signal: ctl.signal });
          const d = await r.json(); const ps = (d.resources && d.resources.results.products) || [];
          if (!ps.length) { box.innerHTML = '<p class="el-suggest__none">Nothing for "' + v.replace(/[<>&"]/g, '') + '" yet. Try dress, cardigan or set.</p>'; box.hidden = false; return; }
          box.innerHTML = ps.map(p => '<a class="el-suggest__item" role="option" href="' + p.url.split('?')[0] + '">' + (p.image ? '<img src="' + p.image + (p.image.includes('?') ? '&' : '?') + 'width=120" alt="" width="48" height="64" loading="lazy">' : '<span></span>') + '<span><b>' + p.title.replace(/</g, '&lt;') + '</b><small>' + money(Math.round(parseFloat(p.price_min || p.price) * 100)) + '</small></span></a>').join('') +
            '<a class="el-suggest__all" href="' + root + 'search?type=product&q=' + encodeURIComponent(v) + '">See every result</a>';
          box.hidden = false;
        } catch (e) {}
      }, 180);
    });
    document.addEventListener('click', e => { if (!f.contains(e.target)) box.hidden = true; });
    q.addEventListener('keydown', e => { if (e.key === 'Escape') box.hidden = true; });
  });
})();
